<template>
    <div :class="['Radio', {'Radio--active': active}]" @click="selectHandle">
        <div class="Radio__container"/>
        <div class="Radio__label" v-if="label">{{label}}</div>
    </div>
</template>

<script>
export default {
    name: "Radio",
    model: {
        prop: 'active',
        event: 'select'
    },
    props: {
        active: Boolean,
        label: String,
    },
    methods: {
        selectHandle() {
            this.$emit('select', !this.active);
        }
    }
}
</script>

<style lang="scss">
.Radio {
  cursor: pointer;
  display: flex;
  align-items: center;

  &--active {

    .Radio__container {
      border-width: 6px;
      border-color: $textLightBlack;
    }
  }

  &__container {
    width: 20px;
    height: 20px;

    border: 2px solid #CED0D6;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__label {
    color: $textBlack;
    margin-left: 8px;
  }
}
</style>